module.exports = __webpack_public_path__ + "img/rebot_1.403e11ed.png";